const onRevoke = (): void => {
  if (typeof window !== 'undefined') {
    window.heap.loaded = false;
  }
};

export default onRevoke;
